const BASE_URL = process.env.REACT_APP_BASE_URL || '';

let isRefreshing = false;
let refreshSubscribers = [];

const onRefreshed = (token) => {
  refreshSubscribers.forEach(cb => cb(token));
  refreshSubscribers = [];
};

const addRefreshSubscriber = (cb) => refreshSubscribers.push(cb);

async function tryRefreshToken() {
  const token = localStorage.getItem('token');
  if (!token) return false;
  try {
    const res = await fetch(`${BASE_URL}/api/users/refresh-token`, {
      method: 'POST',
      headers: { 'Authorization': `Bearer ${token}` },
    });
    if (!res.ok) return false;
    const data = await res.json();
    const newToken = data.token || data.accessToken || data.access_token || data.jwt;
    if (!newToken) return false;
    localStorage.setItem('token', newToken);
    return newToken;
  } catch {
    return false;
  }
}

export async function fetchWithAuth(pathOrUrl, options = {}) {
  const token = localStorage.getItem('token');
  const headers = { ...(options.headers || {}) };
  if (token) headers['Authorization'] = `Bearer ${token}`;

  const url = pathOrUrl.startsWith('http://') || pathOrUrl.startsWith('https://')
    ? pathOrUrl
    : `${BASE_URL}${pathOrUrl}`;

  const res = await fetch(url, { ...options, headers });

  // Sliding Expiration - שמירת טוקן מחודש
  const newToken = res.headers.get('X-New-Token');
  if (newToken) localStorage.setItem('token', newToken);

  if (res.status === 401) {
    if (!isRefreshing) {
      isRefreshing = true;
      const refreshed = await tryRefreshToken();
      isRefreshing = false;

      if (refreshed) {
        onRefreshed(refreshed);
        const retryHeaders = { ...headers, Authorization: `Bearer ${refreshed}` };
        return fetch(url, { ...options, headers: retryHeaders });
      } else {
        refreshSubscribers = [];
        localStorage.removeItem('token');
        localStorage.removeItem('user');
        window.dispatchEvent(new Event('auth:logout'));
        return res;
      }
    }

    // קריאות מקבילות ממתינות לרענון
    const retryToken = await new Promise(resolve => addRefreshSubscriber(resolve));
    const retryHeaders = { ...headers, Authorization: `Bearer ${retryToken}` };
    return fetch(url, { ...options, headers: retryHeaders });
  }

  return res;
}

export default fetchWithAuth;
